module.exports = __webpack_public_path__ + "fonts/5a488c3dab6ff8ccfa74bbd909a7bb95.woff2";